import TitleSortAttribute from './Sort/TitleSortAttribute';

const TitleListType = {
	Catalog: {
		key: 'catalog',
		label: 'Catalog',
		defaultSortAttribute: TitleSortAttribute.Sequence,
		isSortDirectionAsc: true,
	},
	SavedFilter: {
		key: 'savedFilter',
		label: 'SavedFilter',
		defaultSortAttribute: TitleSortAttribute.OnSaleDate,
		isSortDirectionAsc: false,
	},
	Shelf: {
		key: 'shelf',
		label: 'Shelf',
		defaultSortAttribute: TitleSortAttribute.Sequence,
		isSortDirectionAsc: true,
	},
	ReviewCopies: {
		key: 'reviewCopies',
		label: 'Review Copies',
		defaultSortAttribute: TitleSortAttribute.DigitalUpdatedDate,
		isSortDirectionAsc: false,
	},
	CollaborativeList: {
		key: 'collaborativeList',
		label: 'Net Votes',
		defaultSortAttribute: TitleSortAttribute.NetVotes,
		isSortDirectionAsc: false,
	},
	Buzz: {
		key: 'buzz',
		label: 'Buzz',
		defaultSortAttribute: TitleSortAttribute.CommunityReviews,
		isSortDirectionAsc: false,
	},
};

export default TitleListType;
